const merge = require('lodash.merge')

const webhookEN = require('../i18n/content/translations/en/webhook.json')
const webhookES = require('../i18n/content/translations/es/webhook.json')
const webhookPtBR = require('../i18n/content/pt-br/webhook.json')

const subscriptionEN = require('../i18n/content/translations/en/subscription.json')
const subscriptionES = require('../i18n/content/translations/es/subscription.json')
const subscriptionPtBR = require('../i18n/content/pt-br/subscription.json')

const salesEN = require('../i18n/content/translations/en/sales.json')
const salesES = require('../i18n/content/translations/es/sales.json')
const salesPtBR = require('../i18n/content/pt-br/sales.json')
const productEN = require('../i18n/content/translations/en/product.json')
const productES = require('../i18n/content/translations/es/product.json')
const productPtBR = require('../i18n/content/pt-br/product.json')

const sharedEN = require('../i18n/content/translations/en/shared.json')
const sharedES = require('../i18n/content/translations/es/shared.json')
const sharedPtBR = require('../i18n/content/pt-br/shared.json')

const paymentLinkEN = require('../i18n/content/translations/en/payment-link.json')
const paymentLinkES = require('../i18n/content/translations/es/payment-link.json')
const paymentLinkPtBR = require('../i18n/content/pt-br/payment-link.json')

const clubEN = require('../i18n/content/translations/en/club.json')
const clubES = require('../i18n/content/translations/es/club.json')
const clubPtBR = require('../i18n/content/pt-br/club.json')

const couponEN = require('../i18n/content/translations/en/coupon.json')
const couponES = require('../i18n/content/translations/es/coupon.json')
const couponPtBR = require('../i18n/content/pt-br/coupon.json')

const ticketsEN = require('../i18n/content/translations/en/tickets.json')
const ticketsES = require('../i18n/content/translations/es/tickets.json')
const ticketsPtBR = require('../i18n/content/pt-br/tickets.json')

const negotiateEN = require('../i18n/content/translations/en/negotiate.json')
const negotiateES = require('../i18n/content/translations/es/negotiate.json')
const negotiatePtBR = require('../i18n/content/pt-br/negotiate.json')

const changelogEN_2021_09 = require('../i18n/content/translations/en/changelog/2021/09.json')
const changelogEN_2021_12 = require('../i18n/content/translations/en/changelog/2021/12.json')
const changelogEN_2022_01 = require('../i18n/content/translations/en/changelog/2022/01.json')
const changelogEN_2022_02 = require('../i18n/content/translations/en/changelog/2022/02.json')
const changelogEN_2022_03 = require('../i18n/content/translations/en/changelog/2022/03.json')
const changelogEN_2022_04 = require('../i18n/content/translations/en/changelog/2022/04.json')
const changelogEN_2022_05 = require('../i18n/content/translations/en/changelog/2022/05.json')
const changelogEN_2022_06 = require('../i18n/content/translations/en/changelog/2022/06.json')
const changelogEN_2022_08 = require('../i18n/content/translations/en/changelog/2022/08.json')
const changelogEN_2022_09 = require('../i18n/content/translations/en/changelog/2022/09.json')
const changelogEN_2022_10 = require('../i18n/content/translations/en/changelog/2022/10.json')
const changelogEN_2022_11 = require('../i18n/content/translations/en/changelog/2022/11.json')
const changelogEN_2022_12 = require('../i18n/content/translations/en/changelog/2022/12.json')
const changelogEN_2023_01 = require('../i18n/content/translations/en/changelog/2023/01.json')
const changelogEN_2023_02 = require('../i18n/content/translations/en/changelog/2023/02.json')
const changelogEN_2023_03 = require('../i18n/content/translations/en/changelog/2023/03.json')
const changelogEN_2023_05 = require('../i18n/content/translations/en/changelog/2023/05.json')
const changelogEN_2023_10 = require('../i18n/content/translations/en/changelog/2023/10.json')
const changelogEN_2023_12 = require('../i18n/content/translations/en/changelog/2023/12.json')
const changelogEN_2024_01 = require('../i18n/content/translations/en/changelog/2024/01.json')
const changelogEN_2024_03 = require('../i18n/content/translations/en/changelog/2024/03.json')
const changelogEN_2024_04 = require('../i18n/content/translations/en/changelog/2024/04.json')
const changelogEN_2024_07 = require('../i18n/content/translations/en/changelog/2024/07.json')
const changelogEN_2024_10 = require('../i18n/content/translations/en/changelog/2024/10.json')
const changelogEN = merge(
  changelogEN_2021_09,
  changelogEN_2021_12,
  changelogEN_2022_01,
  changelogEN_2022_02,
  changelogEN_2022_03,
  changelogEN_2022_04,
  changelogEN_2022_05,
  changelogEN_2022_06,
  changelogEN_2022_08,
  changelogEN_2022_09,
  changelogEN_2022_10,
  changelogEN_2022_11,
  changelogEN_2022_12,
  changelogEN_2023_01,
  changelogEN_2023_02,
  changelogEN_2023_03,
  changelogEN_2023_05,
  changelogEN_2023_10,
  changelogEN_2023_12,
  changelogEN_2024_01,
  changelogEN_2024_03,
  changelogEN_2024_04,
  changelogEN_2024_07,
  changelogEN_2024_10
)

const changelogES_2021_09 = require('../i18n/content/translations/es/changelog/2021/09.json')
const changelogES_2021_12 = require('../i18n/content/translations/es/changelog/2021/12.json')
const changelogES_2022_01 = require('../i18n/content/translations/es/changelog/2022/01.json')
const changelogES_2022_02 = require('../i18n/content/translations/es/changelog/2022/02.json')
const changelogES_2022_03 = require('../i18n/content/translations/es/changelog/2022/03.json')
const changelogES_2022_04 = require('../i18n/content/translations/es/changelog/2022/04.json')
const changelogES_2022_05 = require('../i18n/content/translations/es/changelog/2022/05.json')
const changelogES_2022_06 = require('../i18n/content/translations/es/changelog/2022/06.json')
const changelogES_2022_08 = require('../i18n/content/translations/es/changelog/2022/08.json')
const changelogES_2022_09 = require('../i18n/content/translations/es/changelog/2022/09.json')
const changelogES_2022_10 = require('../i18n/content/translations/es/changelog/2022/10.json')
const changelogES_2022_11 = require('../i18n/content/translations/es/changelog/2022/11.json')
const changelogES_2022_12 = require('../i18n/content/translations/es/changelog/2022/12.json')
const changelogES_2023_01 = require('../i18n/content/translations/es/changelog/2023/01.json')
const changelogES_2023_02 = require('../i18n/content/translations/es/changelog/2023/02.json')
const changelogES_2023_03 = require('../i18n/content/translations/es/changelog/2023/03.json')
const changelogES_2023_05 = require('../i18n/content/translations/es/changelog/2023/05.json')
const changelogES_2023_10 = require('../i18n/content/translations/es/changelog/2023/10.json')
const changelogES_2023_12 = require('../i18n/content/translations/es/changelog/2023/12.json')
const changelogES_2024_01 = require('../i18n/content/translations/es/changelog/2024/01.json')
const changelogES_2024_03 = require('../i18n/content/translations/es/changelog/2024/03.json')
const changelogES_2024_04 = require('../i18n/content/translations/es/changelog/2024/04.json')
const changelogES_2024_07 = require('../i18n/content/translations/es/changelog/2024/07.json')
const changelogES_2024_10 = require('../i18n/content/translations/es/changelog/2024/10.json')
const changelogES = merge(
  changelogES_2021_09,
  changelogES_2021_12,
  changelogES_2022_01,
  changelogES_2022_02,
  changelogES_2022_03,
  changelogES_2022_04,
  changelogES_2022_05,
  changelogES_2022_06,
  changelogES_2022_08,
  changelogES_2022_09,
  changelogES_2022_10,
  changelogES_2022_11,
  changelogES_2022_12,
  changelogES_2023_01,
  changelogES_2023_02,
  changelogES_2023_03,
  changelogES_2023_05,
  changelogES_2023_10,
  changelogES_2023_12,
  changelogES_2024_01,
  changelogES_2024_03,
  changelogES_2024_04,
  changelogES_2024_07,
  changelogES_2024_10
)

const changelogPtBR_2021_09 = require('../i18n/content/pt-br/changelog/2021/09.json')
const changelogPtBR_2021_12 = require('../i18n/content/pt-br/changelog/2021/12.json')
const changelogPtBR_2022_01 = require('../i18n/content/pt-br/changelog/2022/01.json')
const changelogPtBR_2022_02 = require('../i18n/content/pt-br/changelog/2022/02.json')
const changelogPtBR_2022_03 = require('../i18n/content/pt-br/changelog/2022/03.json')
const changelogPtBR_2022_04 = require('../i18n/content/pt-br/changelog/2022/04.json')
const changelogPtBR_2022_05 = require('../i18n/content/pt-br/changelog/2022/05.json')
const changelogPtBR_2022_06 = require('../i18n/content/pt-br/changelog/2022/06.json')
const changelogPtBR_2022_08 = require('../i18n/content/pt-br/changelog/2022/08.json')
const changelogPtBR_2022_09 = require('../i18n/content/pt-br/changelog/2022/09.json')
const changelogPtBR_2022_10 = require('../i18n/content/pt-br/changelog/2022/10.json')
const changelogPtBR_2022_11 = require('../i18n/content/pt-br/changelog/2022/11.json')
const changelogPtBR_2022_12 = require('../i18n/content/pt-br/changelog/2022/12.json')
const changelogPtBR_2023_01 = require('../i18n/content/pt-br/changelog/2023/01.json')
const changelogPtBR_2023_02 = require('../i18n/content/pt-br/changelog/2023/02.json')
const changelogPtBR_2023_03 = require('../i18n/content/pt-br/changelog/2023/03.json')
const changelogPtBR_2023_05 = require('../i18n/content/pt-br/changelog/2023/05.json')
const changelogPtBR_2023_10 = require('../i18n/content/pt-br/changelog/2023/10.json')
const changelogPtBR_2023_12 = require('../i18n/content/pt-br/changelog/2023/12.json')
const changelogPtBR_2024_01 = require('../i18n/content/pt-br/changelog/2024/01.json')
const changelogPtBR_2024_03 = require('../i18n/content/pt-br/changelog/2024/03.json')
const changelogPtBR_2024_04 = require('../i18n/content/pt-br/changelog/2024/04.json')
const changelogPtBR_2024_07 = require('../i18n/content/pt-br/changelog/2024/07.json')
const changelogPtBR_2024_10 = require('../i18n/content/pt-br/changelog/2024/10.json')
const changelogPtBR = merge(
  changelogPtBR_2021_09,
  changelogPtBR_2021_12,
  changelogPtBR_2022_01,
  changelogPtBR_2022_02,
  changelogPtBR_2022_03,
  changelogPtBR_2022_04,
  changelogPtBR_2022_05,
  changelogPtBR_2022_06,
  changelogPtBR_2022_08,
  changelogPtBR_2022_09,
  changelogPtBR_2022_10,
  changelogPtBR_2022_11,
  changelogPtBR_2022_12,
  changelogPtBR_2023_01,
  changelogPtBR_2023_02,
  changelogPtBR_2023_03,
  changelogPtBR_2023_05,
  changelogPtBR_2023_10,
  changelogPtBR_2023_12,
  changelogPtBR_2024_01,
  changelogPtBR_2024_03,
  changelogPtBR_2024_04,
  changelogPtBR_2024_07,
  changelogPtBR_2024_10
)

const tutorialSharedEN = require('../i18n/content/translations/en/tutorials/shared.json')
const tutorialOverdueSubscriptionsEN = require('../i18n/content/translations/en/tutorials/overdue-subscriptions.json')
const tutorialCanceledSubscriptionsEN = require('../i18n/content/translations/en/tutorials/canceled-subscriptions.json')
const tutorialCheckoutElementsEN = require('../i18n/content/translations/en/tutorials/checkout-elements.json')
const tutorialClubEngagementEN = require('../i18n/content/translations/en/tutorials/club-engagement.json')
const tutorialLearnGoodUsagePracticesEN = require('../i18n/content/translations/en/tutorials/learn-good-usage-practices.json')
const tutorialUseWebhookForSubscriptionsEN = require('../i18n/content/translations/en/tutorials/use-webhook-for-subscriptions.json')
const tutorialSubscriptionsSpreadsheetEN = require('../i18n/content/translations/en/tutorials/subscriptions-google-spreadsheet.json')
const tutorialCreateShoppingCartEN = require('../i18n/content/translations/en/tutorials/create-shopping-cart.json')
const tutorialHotmartAuthenticationEN = require('../i18n/content/translations/en/tutorials/hotmart-authentication-create-credentials.json')
const tutorialsEN = merge(
  tutorialSharedEN,
  tutorialOverdueSubscriptionsEN,
  tutorialCanceledSubscriptionsEN,
  tutorialCheckoutElementsEN,
  tutorialClubEngagementEN,
  tutorialLearnGoodUsagePracticesEN,
  tutorialUseWebhookForSubscriptionsEN,
  tutorialSubscriptionsSpreadsheetEN,
  tutorialCreateShoppingCartEN,
  tutorialHotmartAuthenticationEN
)

const tutorialSharedES = require('../i18n/content/translations/es/tutorials/shared.json')
const tutorialOverdueSubscriptionsES = require('../i18n/content/translations/es/tutorials/overdue-subscriptions.json')
const tutorialCanceledSubscriptionsES = require('../i18n/content/translations/es/tutorials/canceled-subscriptions.json')
const tutorialCheckoutElementsES = require('../i18n/content/translations/es/tutorials/checkout-elements.json')
const tutorialClubEngagementES = require('../i18n/content/translations/es/tutorials/club-engagement.json')
const tutorialLearnGoodUsagePracticesES = require('../i18n/content/translations/es/tutorials/learn-good-usage-practices.json')
const tutorialUseWebhookForSubscriptionsES = require('../i18n/content/translations/es/tutorials/use-webhook-for-subscriptions.json')
const tutorialSubscriptionsSpreadsheetES = require('../i18n/content/translations/es/tutorials/subscriptions-google-spreadsheet.json')
const tutorialCreateShoppingCartES = require('../i18n/content/translations/es/tutorials/create-shopping-cart.json')
const tutorialHotmartAuthenticationES = require('../i18n/content/translations/es/tutorials/hotmart-authentication-create-credentials.json')
const tutorialsES = merge(
  tutorialSharedES,
  tutorialOverdueSubscriptionsES,
  tutorialCanceledSubscriptionsES,
  tutorialCheckoutElementsES,
  tutorialClubEngagementES,
  tutorialLearnGoodUsagePracticesES,
  tutorialUseWebhookForSubscriptionsES,
  tutorialSubscriptionsSpreadsheetES,
  tutorialCreateShoppingCartES,
  tutorialHotmartAuthenticationES
)

const tutorialSharedPtBR = require('../i18n/content/pt-br/tutorials/shared.json')
const tutorialOverdueSubscriptionsPtBR = require('../i18n/content/pt-br/tutorials/overdue-subscriptions.json')
const tutorialCanceledSubscriptionsPtBR = require('../i18n/content/pt-br/tutorials/canceled-subscriptions.json')
const tutorialCheckoutElementsPtBR = require('../i18n/content/pt-br/tutorials/checkout-elements.json')
const tutorialClubEngagementPtBR = require('../i18n/content/pt-br/tutorials/club-engagement.json')
const tutorialLearnGoodUsagePracticesPtBR = require('../i18n/content/pt-br/tutorials/learn-good-usage-practices.json')
const tutorialUseWebhookForSubscriptionsPtBR = require('../i18n/content/pt-br/tutorials/use-webhook-for-subscriptions.json')
const tutorialSubscriptionsSpreadsheetPtBR = require('../i18n/content/pt-br/tutorials/subscriptions-google-spreadsheet.json')
const tutorialCreateShoppingCartPtBR = require('../i18n/content/pt-br/tutorials/create-shopping-cart.json')
const tutorialHotmartAuthenticationPtBR = require('../i18n/content/pt-br/tutorials/hotmart-authentication-create-credentials.json')
const tutorialsPtBR = merge(
  tutorialSharedPtBR,
  tutorialOverdueSubscriptionsPtBR,
  tutorialCanceledSubscriptionsPtBR,
  tutorialCheckoutElementsPtBR,
  tutorialClubEngagementPtBR,
  tutorialLearnGoodUsagePracticesPtBR,
  tutorialUseWebhookForSubscriptionsPtBR,
  tutorialSubscriptionsSpreadsheetPtBR,
  tutorialCreateShoppingCartPtBR,
  tutorialHotmartAuthenticationPtBR
)

exports.langContentEN = merge(
  sharedEN,
  webhookEN,
  subscriptionEN,
  salesEN,
  productEN,
  changelogEN,
  tutorialsEN,
  paymentLinkEN,
  clubEN,
  couponEN,
  ticketsEN,
  negotiateEN
)
exports.langContentES = merge(
  sharedES,
  webhookES,
  subscriptionES,
  salesES,
  productES,
  changelogES,
  tutorialsES,
  paymentLinkES,
  clubES,
  couponES,
  ticketsES,
  negotiateES
)
exports.langContentPtBR = merge(
  sharedPtBR,
  webhookPtBR,
  subscriptionPtBR,
  salesPtBR,
  productPtBR,
  changelogPtBR,
  tutorialsPtBR,
  paymentLinkPtBR,
  clubPtBR,
  couponPtBR,
  ticketsPtBR,
  negotiatePtBR
)
